import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, LinearProgress, Stack, Typography, } from '@mui/material';
import { ChevronDown, CheckCircle, Pencil } from 'mdi-material-ui';
import { useState } from 'react';
import AboutBrand from './AboutBrand';
import CampaignDetails from './CampaignDetails';
import TargetGroup from './TargetGroup';
import MediaPreference from './MediaPreference';
import MediaSpecificDetails from './MediaSpecificDetails';
import Badge from '../../SvgIcons/Badge';
import Announcement from '../../SvgIcons/Announcement';
import Target from '../../SvgIcons/Target';
import Options from '../../SvgIcons/Options';
import Movie from '../../SvgIcons/Movie';
import FilledAboutBrand from './FilledCampaignBrief/FilledAboutBrand';
import FilledCampaignDetails from './FilledCampaignBrief/FilledCampaignDetails';
import FilledTargetGroup from './FilledCampaignBrief/FilledTargetGroup';
import FilledMediaPreference from './FilledCampaignBrief/FilledMediaPreference';
import FilledMediaSpecificDetails from './FilledCampaignBrief/FilledMediaSpecificDetails';
const accordionData = [
    {
        title: 'About The Brand',
        icon: Badge,
        key: 'brand',
        data: 'About Brand',
        component: AboutBrand,
        filledComponent: FilledAboutBrand,
    },
    {
        title: 'Campaign Details',
        icon: Announcement,
        key: 'campaignDetails',
        data: 'Campaign Details',
        component: CampaignDetails,
        filledComponent: FilledCampaignDetails,
    },
    {
        title: 'Target Audience',
        icon: Target,
        component: TargetGroup,
        key: 'targetGroup',
        filledComponent: FilledTargetGroup,
    },
    {
        title: 'Media Preferences',
        icon: Options,
        component: MediaPreference,
        key: 'mediaPreference',
        filledComponent: FilledMediaPreference,
    },
    {
        title: 'Media Specific Details',
        icon: Movie,
        component: MediaSpecificDetails,
        key: 'mediaSpecificDetils',
        filledComponent: FilledMediaSpecificDetails,
    },
];
//const admin = process.env.REACT_APP_ADMIN || false;
export default function CampaignBriefAccordian({ brief, editMode, inputProgressValue, setEditMode, apiService, enableEdit, }) {
    var _a;
    const [editedObj, setEditedObj] = useState([{}]);
    const [progressValue, setProgressValue] = useState(20);
    const [expanded, setExpanded] = useState('brand');
    const [touchedSection, setTouchedSections] = useState(['brand']);
    const isFilled = ((_a = brief === null || brief === void 0 ? void 0 : brief.brand) === null || _a === void 0 ? void 0 : _a.name) ? true : false;
    const handleChange = (panel, idx, key) => (event, isExpanded) => {
        setExpanded(isExpanded ? key : false);
        if (!touchedSection.includes(key)) {
            setProgressValue((prevState) => {
                const percentage = (touchedSection === null || touchedSection === void 0 ? void 0 : touchedSection.length) * 20 + 20;
                if (percentage <= prevState) {
                    return prevState;
                }
                return prevState < 100 ? prevState + 20 : prevState;
            });
            setTouchedSections((prev) => [...prev, key]);
        }
    };
    function handleNextStep(idx) {
        var _a, _b, _c;
        let key = (_a = accordionData[idx]) === null || _a === void 0 ? void 0 : _a.key;
        if (editedObj.indexOf((_b = accordionData[idx]) === null || _b === void 0 ? void 0 : _b.key) === -1) {
            setEditedObj((prev) => { var _a; return [...prev, (_a = accordionData[idx]) === null || _a === void 0 ? void 0 : _a.key]; });
        }
        idx === 4 ? setExpanded(false) : setExpanded((_c = accordionData[idx + 1]) === null || _c === void 0 ? void 0 : _c.key);
        if (!(touchedSection === null || touchedSection === void 0 ? void 0 : touchedSection.includes(key))) {
            setProgressValue((prev) => {
                const percentage = (touchedSection === null || touchedSection === void 0 ? void 0 : touchedSection.length) * 20 + 20;
                if (percentage <= prev) {
                    return prev;
                }
                return prev < 100 ? prev + 20 : prev;
            });
            setTouchedSections((prev) => [...prev, key]);
        }
    }
    const CustomExpandIcon = () => (_jsx(Stack, Object.assign({ sx: {
            backgroundColor: '#F5F4FC',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            justifyContent: 'center',
            alignItems: 'center',
        } }, { children: _jsx(ChevronDown, { color: "primary" }) })));
    return (_jsxs("div", { children: [enableEdit ? (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(Stack, Object.assign({ direction: "row", spacing: 2, alignItems: "center" }, { children: [_jsx(Announcement, {}), _jsx(Typography, Object.assign({ variant: "h3", fontWeight: 500 }, { children: "Campaign Brief" }))] })), !editMode && (_jsxs(Button, Object.assign({ variant: "text", color: "primary", sx: { fontSize: '14px', fontWeight: 500 }, onClick: () => setEditMode(true) }, { children: [_jsx(Pencil, { style: { fontSize: '14px' } }), "Edit"] })))] }))) : (_jsx(_Fragment, {})), _jsxs(Box, { children: [_jsxs(Typography, Object.assign({ variant: "body2", color: "text.dark", sx: { textAlign: 'end' } }, { children: [inputProgressValue, "% completed"] })), _jsx(LinearProgress, { variant: "determinate", value: isFilled
                            ? inputProgressValue === 0
                                ? 100
                                : inputProgressValue
                            : inputProgressValue, sx: {
                            backgroundColor: 'border.disabled',
                            mt: 1,
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: 'primary.main',
                            },
                        } })] }), _jsx(Stack, Object.assign({ gap: '24px' }, { children: accordionData.map((elem, idx) => {
                    const Icon = elem.icon;
                    const Component = elem.component;
                    const FilledComponent = elem === null || elem === void 0 ? void 0 : elem.filledComponent;
                    return (_jsxs(Accordion, Object.assign({ expanded: expanded === elem.key, onChange: handleChange(`panel_${idx}`, idx, elem === null || elem === void 0 ? void 0 : elem.key), classes: { expanded: 'expandIcon' }, sx: {
                            fontSize: '32px',
                            margin: '0px',
                            padding: '3px',
                            '&.MuiAccordion-root': {
                                borderRadius: '8px',
                            },
                            '&.MuiAccordion-root:before': {
                                backgroundColor: 'rgba(0, 0, 0, 0)',
                            },
                        } }, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(CustomExpandIcon, {}) }, { children: _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 2 }, { children: [_jsx(Icon, {}), _jsx(Typography, Object.assign({ variant: "body1", color: "text.dark" }, { children: elem === null || elem === void 0 ? void 0 : elem.title })), ((editedObj === null || editedObj === void 0 ? void 0 : editedObj.indexOf(elem === null || elem === void 0 ? void 0 : elem.key)) > -1 || isFilled) && (_jsx(CheckCircle, { sx: { color: 'success.main', fontSize: '14px' } }))] })) })), _jsx(Divider, {}), _jsx(AccordionDetails, { children: isFilled && !editMode ? (_jsx(FilledComponent, { brief: brief })) : (_jsx(Component, { apiService: apiService, handleNextStep: handleNextStep, msdIdx: idx })) })] }), idx));
                }) }))] }));
}
